import { render } from "./UserGroupToplistTable.vue?vue&type=template&id=1d4503e8&scoped=true"
import script from "./UserGroupToplistTable.vue?vue&type=script&lang=js"
export * from "./UserGroupToplistTable.vue?vue&type=script&lang=js"

import "./UserGroupToplistTable.vue?vue&type=style&index=0&id=1d4503e8&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4503e8"]])

export default __exports__